// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-item-card {
   padding: var(--padding);
   display: flex;
   /* align-items: center; */
}

.comment-item .left {
   align-self: flex-start;
}

.comment-item .top {
   display: flex;
   /* align-items: center; */
   padding: var(--padding-sm);
}

.comment-item .bottom {
   padding-left: 40px;
}

.comment-item .username {
   padding: var(--padding-sm);
}

.comment-item .date {
   padding: var(--padding-sm);
}

.ecl-comments .view-btn.false {
   opacity: var(--widget-disabled-opacity);
}

.comment-sort-button {
   display: flex;
}

.comment-sort-button p {
   padding: 0;
   padding-right: 5px;
}

@media only screen and (min-width: 360px) and (max-width: 480px) {
   .ecl-comments{
      width: auto;
      max-width: 89vw;
   }

   .comments-view {
      max-width: 85vw;
   }

   .comments-list{
      width: auto;
   }

   .comment-item-card {
      max-width: 85vw;
   }

   .comment-item .left {
      align-self: flex-start;
      min-width: 65vw;
   }
   
   .comment-item .top {
      display: flex;
      /* align-items: center; */
      padding: 2px;
   }
   
   .comment-item .bottom {
      padding-left: 40px;
   }
   
   .comment-item .username {
      padding: var(--padding-sm);
   }
   
   .comment-item .date {
      padding: var(--padding-sm);
   }
   
   .ecl-comments .view-btn.false {
      opacity: var(--widget-disabled-opacity);
   }

   .comments-list > .comment-item .bottom > .rich-text-container {
      width: auto;
      height: auto;
      overflow: auto;
      display: flex;
      flex-direction: column;
      max-width: 60vw;
   }
}

@media only screen and (min-height: 360px) and (max-height: 480px) and (orientation: landscape) {
   .ecl-comments{
      width: auto;
      max-width: 89vw;
   }

   .comments-view {
      max-width: 85vw;
   }

   .comments-list {
      width: auto;
   }

   .comment-item-card {
      max-width: 85vw;
   }

   .comment-item .left {
      align-self: flex-start;
      min-width: 65vw;
   }

   .comment-item .bottom {
      display: flex;
      padding: 2px;
   }

   .comments-list > .comment-item .bottom > .rich-text-container {
      width: auto;
      height: auto;
      overflow: auto;
      display: flex;
      flex-direction: column;
      max-width: 60vw;
   }

}

@media only screen and (min-width: 481px) and (max-width: 769px) {
   .comment-item .left {
      max-width: 80vw;
      width: auto;
   }
}

@media only screen and (min-width: 769px) and (max-width: 820px) {
   .commment-item .left {
      max-width: 80vw;
      width: auto;
   }
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLComments/ECLComments.css"],"names":[],"mappings":"AAAA;GACG,uBAAuB;GACvB,aAAa;GACb,yBAAyB;AAC5B;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,aAAa;GACb,yBAAyB;GACzB,0BAA0B;AAC7B;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,uCAAuC;AAC1C;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,kBAAkB;AACrB;;AAEA;GACG;MACG,WAAW;MACX,eAAe;GAClB;;GAEA;MACG,eAAe;GAClB;;GAEA;MACG,WAAW;GACd;;GAEA;MACG,eAAe;GAClB;;GAEA;MACG,sBAAsB;MACtB,eAAe;GAClB;;GAEA;MACG,aAAa;MACb,yBAAyB;MACzB,YAAY;GACf;;GAEA;MACG,kBAAkB;GACrB;;GAEA;MACG,0BAA0B;GAC7B;;GAEA;MACG,0BAA0B;GAC7B;;GAEA;MACG,uCAAuC;GAC1C;;GAEA;MACG,WAAW;MACX,YAAY;MACZ,cAAc;MACd,aAAa;MACb,sBAAsB;MACtB,eAAe;GAClB;AACH;;AAEA;GACG;MACG,WAAW;MACX,eAAe;GAClB;;GAEA;MACG,eAAe;GAClB;;GAEA;MACG,WAAW;GACd;;GAEA;MACG,eAAe;GAClB;;GAEA;MACG,sBAAsB;MACtB,eAAe;GAClB;;GAEA;MACG,aAAa;MACb,YAAY;GACf;;GAEA;MACG,WAAW;MACX,YAAY;MACZ,cAAc;MACd,aAAa;MACb,sBAAsB;MACtB,eAAe;GAClB;;AAEH;;AAEA;GACG;MACG,eAAe;MACf,WAAW;GACd;AACH;;AAEA;GACG;MACG,eAAe;MACf,WAAW;GACd;AACH","sourcesContent":[".comment-item-card {\r\n   padding: var(--padding);\r\n   display: flex;\r\n   /* align-items: center; */\r\n}\r\n\r\n.comment-item .left {\r\n   align-self: flex-start;\r\n}\r\n\r\n.comment-item .top {\r\n   display: flex;\r\n   /* align-items: center; */\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.comment-item .bottom {\r\n   padding-left: 40px;\r\n}\r\n\r\n.comment-item .username {\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.comment-item .date {\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.ecl-comments .view-btn.false {\r\n   opacity: var(--widget-disabled-opacity);\r\n}\r\n\r\n.comment-sort-button {\r\n   display: flex;\r\n}\r\n\r\n.comment-sort-button p {\r\n   padding: 0;\r\n   padding-right: 5px;\r\n}\r\n\r\n@media only screen and (min-width: 360px) and (max-width: 480px) {\r\n   .ecl-comments{\r\n      width: auto;\r\n      max-width: 89vw;\r\n   }\r\n\r\n   .comments-view {\r\n      max-width: 85vw;\r\n   }\r\n\r\n   .comments-list{\r\n      width: auto;\r\n   }\r\n\r\n   .comment-item-card {\r\n      max-width: 85vw;\r\n   }\r\n\r\n   .comment-item .left {\r\n      align-self: flex-start;\r\n      min-width: 65vw;\r\n   }\r\n   \r\n   .comment-item .top {\r\n      display: flex;\r\n      /* align-items: center; */\r\n      padding: 2px;\r\n   }\r\n   \r\n   .comment-item .bottom {\r\n      padding-left: 40px;\r\n   }\r\n   \r\n   .comment-item .username {\r\n      padding: var(--padding-sm);\r\n   }\r\n   \r\n   .comment-item .date {\r\n      padding: var(--padding-sm);\r\n   }\r\n   \r\n   .ecl-comments .view-btn.false {\r\n      opacity: var(--widget-disabled-opacity);\r\n   }\r\n\r\n   .comments-list > .comment-item .bottom > .rich-text-container {\r\n      width: auto;\r\n      height: auto;\r\n      overflow: auto;\r\n      display: flex;\r\n      flex-direction: column;\r\n      max-width: 60vw;\r\n   }\r\n}\r\n\r\n@media only screen and (min-height: 360px) and (max-height: 480px) and (orientation: landscape) {\r\n   .ecl-comments{\r\n      width: auto;\r\n      max-width: 89vw;\r\n   }\r\n\r\n   .comments-view {\r\n      max-width: 85vw;\r\n   }\r\n\r\n   .comments-list {\r\n      width: auto;\r\n   }\r\n\r\n   .comment-item-card {\r\n      max-width: 85vw;\r\n   }\r\n\r\n   .comment-item .left {\r\n      align-self: flex-start;\r\n      min-width: 65vw;\r\n   }\r\n\r\n   .comment-item .bottom {\r\n      display: flex;\r\n      padding: 2px;\r\n   }\r\n\r\n   .comments-list > .comment-item .bottom > .rich-text-container {\r\n      width: auto;\r\n      height: auto;\r\n      overflow: auto;\r\n      display: flex;\r\n      flex-direction: column;\r\n      max-width: 60vw;\r\n   }\r\n\r\n}\r\n\r\n@media only screen and (min-width: 481px) and (max-width: 769px) {\r\n   .comment-item .left {\r\n      max-width: 80vw;\r\n      width: auto;\r\n   }\r\n}\r\n\r\n@media only screen and (min-width: 769px) and (max-width: 820px) {\r\n   .commment-item .left {\r\n      max-width: 80vw;\r\n      width: auto;\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
